import React from 'react'

export const Li = ({content} ) => {
    return (
        <li className="point">{content}</li>
    )
}